import { render, staticRenderFns } from "./AppPieChart.vue?vue&type=template&id=dc6b5284&"
import script from "./AppPieChart.vue?vue&type=script&lang=js&"
export * from "./AppPieChart.vue?vue&type=script&lang=js&"
import style0 from "./AppPieChart.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports